<template>
    <div>
      <div>
        <header class="header__style">
          <div style="position: relative">
            <img src="./../assets/header.png" class="adway__name" alt="Adway name">
            <router-link class="footer-text router-links header__sing__up" to='/login'>SIGN IN</router-link>
          </div>
        </header>
        <section class="section__positioning">
          <img :src="image" class="content__image" alt="landing_image">
        </section>
        <div class="content__name">
          <p class="content__name__context">Earn With Adway</p>
        </div>
      </div>
      <footer class="footer__style">
        <footer-view></footer-view>
      </footer>
    </div>
</template>

<script>
import FooterView from './footer/FooterView.vue'

export default {
  name: 'Main',
  components: {
    FooterView
  },
  data: function () {
    return {
      image: 'https://adwayusa.s3.amazonaws.com/website/lading_page_bg.jpg'
    }
  },
  mounted() {
    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?onload=ReCaptchaLoaded&render=explicit';
    document.head.appendChild(script);
  }
}
</script>

<style scoped>

.header__style {
  position: relative;
  background: linear-gradient(180deg, #0F202F 36.46%, rgba(15, 32, 47, 0) 100%);
  box-shadow: 0px 30px 40px rgba(0, 0, 0, 0.01);
  height: 304px;
}

.adway__name {
  margin-top: 18px;
}

.header__sing__up {
  position: absolute;
  top: 15px;
  right: 30px;
  font-weight: bold;
  font-size: 13px;
  line-height: 20px;
}

.content__image {
  width: 100%;
  height: 100%;
}

.section__positioning {
  margin-top: -270px;
}

.content__name {
  width: 100%;
  height: 304px;
  text-align: center;
  background: rgba(0, 0, 0, 0) linear-gradient(rgb(15, 32, 47) 36.46%, rgba(15, 32, 47, 0) 100%) repeat scroll 0% 0%;
  box-shadow: rgba(0, 0, 0, 0.01) 0px 30px 40px;
  transform: rotate(180deg);
  margin-top: -233px;
  position: relative;
}

.content__name__context {
  width: 100%;
  text-align: center;
  transform: rotate(180deg);
  font-size: 44px;
  line-height: 56px;
}

.footer__style {
  width: 100%; position: relative; bottom: 0; float: left;
}

hr{
  width: 96%;
}
p{
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7em;
  line-height: 20px;
  color: #FFFFFF;
  width: 98%;
  float: left;
  text-align: right;
  margin: 0%;
}

@media only screen and (max-width: 1300px) {

  .section__positioning {
    margin-top: -260px;
  }

}

@media only screen and (max-width: 1100px) {

  .section__positioning {
    margin-top: -240px;
  }

}

@media only screen and (max-width: 1000px) {
  .content__name__context {
    font-size: 40px;
    line-height: 50px;
  }
}

@media only screen and (max-width: 1000px) {
  .content__name__context {
    font-size: 35px;
    line-height: 45px;
  }
}

@media only screen and (max-width: 800px) {
  .section__positioning {
    margin-top: -230px;
  }

  .content__name__context {
    font-size: 30px;
    line-height: 40px;
  }
}

@media only screen and (max-width: 700px) {
  .section__positioning {
    margin-top: -220px;
  }
}

@media only screen and (max-width: 600px) {
  .section__positioning {
    margin-top: -120px;
    margin-left: -330px;
  }

  .header__style {
    height: 185px
  }

  .content__name {
    margin-top: -200px;
  }

}

@media only screen and (max-width: 500px) {
  .section__positioning {
    margin-left: -250px;
    margin-top: -194px;
  }
}

@media only screen and (max-width: 400px) {
  .section__positioning {
    margin-left: -220px;
  }
}

@media only screen and (max-width: 300px) {
  .header__sing__up {
    top: 45px;
    right: 10px;
  }
}

</style>
